// extracted by mini-css-extract-plugin
export default {"productGallery":"zK-z","inQuickShop":"AK-z"};